import React, { useRef, useEffect, useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Button } from 'react-bootstrap';
import {BsFillArrowLeftSquareFill, BsExclamationCircle, BsLock, BsUnlock} from 'react-icons/bs';
import {convertTzDate, updateUTCDate, commonLogDate, getNowDate, showToast} from '../../common/app_common';
import {SeletorWithCalendar} from '../../common/component_common';
import {getApiReceiveEdge, getApiReceiveEdgeId, getApiReceiveEdgeDataQuery, getApiReceiveEdgeDataQueryRange} from '../../common/fetch_api/coverage';
import {utils as xlsxUtils, writeFile as xlsxWriteFile} from 'xlsx'

export const SearchCanvas = ({result, edgeArr, severity, mode, loading, show, handleClose}) => {
    
    const [update, setUpdate] = useState(false);
    const [edgeList, setEdgeList] = useState([]);

    function getSearchInfo()
    {
        let info = [];
        if( mode === 'fixed' )
        {
            if( severity === '' )
            {
                info = [...edgeArr.good, ...edgeArr.normal, ...edgeArr.bad];
            }
            else
            {
                info = edgeArr[severity];
            }
        }
        else
        {
            info = [...edgeArr.good, ...edgeArr.normal, ...edgeArr.bad];
        }

        if( info.length > 0 )
        {
            setEdgeList(
                info.map( (item, idx) => (
                    <tr key={item.id} >
                        <td>
                            <div className='label-edge'>{item.id}</div>
                        </td>
                        <td>
                            <div className='label-edge'>{convertTzDate(item.lock.date)}</div>
                        </td>
                        <td>
                            <div className='label-edge text-start'><span className='ps-2'>{item.lock.value === 1?<BsLock />:<BsUnlock />}</span><span>{`${item.rssi?'| RSSI: '+item.rssi.value:''} ${item.snr?'| SNR: '+item.snr.value:''}`}</span></div>
                        </td>
                        <td>
                            <Button vatiant='primary' className="btn btn-icon" onClick={() => {onClickResult(item)}}><BsExclamationCircle /></Button>
                        </td>
                    </tr>
                ))
            );
        }
        else
        {
            loading(false);
        }
    }

    function onClickResult(item)
    {
        result({id: item.id, coordinates: [item.longitude.value, item.latitude.value]});
        
        if( mode === 'mobile' )
        {
            closeOffcanvas();
            show = false;
        }
    }

    function runUpdate()
    {
        setUpdate(!update);
    }

    const closeOffcanvas = () => {
        handleClose();
        show = false;
    }

    useEffect( () => {
        if( edgeList.length > 0)
        {
            loading(false);
        }
    }, [edgeList] );

    useEffect( () => {
        loading(true);
        getSearchInfo();
    }, [show, update, edgeArr, severity]);

    return (
        <>
            <Offcanvas show={show} onHide={closeOffcanvas} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>Search Receive Edge</Offcanvas.Title>
                    <Button variant='close' className="btn-close-white" onClick={closeOffcanvas}></Button>
                </Offcanvas.Header>
                <Offcanvas.Body>
                <div className="d-flex receive-edge-list-table">
                        <table className="table text-center">
                            <tbody>
                                {edgeList}
                            </tbody>
                        </table>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

const edgeDataFormat = {
    date:'',
    latitude: 0,
    longitude: 0,
    lock: 0,
    freq: 0,
    rssi: 0,
    snr: 0,
    mer: 0,
    plp: 0,
    fer: 0,
    speed: 0
};

export const MobileCanvas = ({drawResult, infoResult, move, curEdgeId, loading, show, handleClose}) => {
    
    const [update, setUpdate] = useState(false);
    const [infomation, setInfomation] = useState({
        clientIp: '',
        date: '',
        fingerprint: '',
        id: '',
        memo: '',
        name: '',
        product: '',
        status: '',
        sec: 0
    });
    const [edgeData, setEdgeData] = useState({...edgeDataFormat});
    const [dateFrom, setDateFrom] = useState('1');
    const [dateTo, setDateTo] = useState('now');
    const [curLogData, setCurLogData] = useState(null);
    const [preLogData, setPreLogData] = useState(null);
    const [drawId, setDrawId] = useState('');
    const [drawData, setDrawData] = useState([]);

    const [optSelectorFrom, setOptSelectorFrom] = useState([
        {value: "1", label: 'Last 1 hour'},
        {value: "6", label: 'Last 6 hour'},
        {value: "24", label: 'Last 1 day'},
        {value: "168", label: 'Last 1 week'},
        {value: 'calendar', label: 'Calendar'}
    ]);
    const [optSelectorTo, setOptSelectorTo] = useState([
        {value: "now", label: 'Now'},
        {value: "calendar", label: 'Calendar'}
    ]);

    function getEdgeInfo()
    {
        if( curEdgeId === drawId && preLogData )
        {
            setCurLogData(preLogData);
        }
        else
        {
            setCurLogData(null);

            setDateFrom('1');
            setDateTo('now');
        }

        if( curEdgeId.length > 0 )
        {
            Promise.resolve( getApiReceiveEdgeId(curEdgeId) )
            .then( receiveData => {
                setInfomation(receiveData);

            });

            Promise.resolve( getApiReceiveEdgeDataQuery(curEdgeId) )
            .then( queryData => {
                
                for( const data of queryData )
                {
                    if( edgeData.hasOwnProperty(data.field)  )
                    {
                        edgeData[data.field] = data.value[0][1];                    
                    }
                }
                
                setEdgeData((prevState) => {
                    return { ...prevState}
                });
            });
        }
    }

    function onClickBackCanvas()
    {
        move();
        closeOffcanvas();
    }

    const onChangeFrom = (value) => {
        setDateFrom(value);

        if( value !== '1' && dateTo === 'now' )
        {
            let date = getNowDate();
            let exist = optSelectorTo.filter( optSelectorTo => optSelectorTo.value === date[0] );
            if(exist.length < 1)
            {
                setOptSelectorTo([...optSelectorTo, {value: date[0], label: date[1]}]);
            }
            setDateTo(date[0]);
        }
    }

    const onChangeTo = (value) => {
        setDateTo(value);
        
        if( value === 'now' && dateFrom !== '1' )
        {
            setDateFrom('1');
        }
    }

    function getObjValue(date, obj, category)
    {
        if( obj.hasOwnProperty(category) )
        {
            const item = obj[category].filter( (x) => {return x[0] === date});

            if( item.length > 0)
            {
                return item[0][1];
            }
            else
            {
                return 0;
            }
        }
        else
        {
            return 0;
        }
    }

    const onClickSearch = () => {
        loading(true);
        
        let from;
        let to;
        let intv = false;
        
        if( dateTo === 'now' )
        {
            intv = true;
            to = parseInt(new Date().getTime()/1000);
            from = to - (parseInt(dateFrom) * 60 * 60);
        }
        else
        {
            to = parseInt(new Date(dateTo).getTime()/1000);
            if( parseInt(dateFrom) > 168 )
            {
                from = parseInt(new Date(dateFrom).getTime()/1000);
            }
            else
            {
                from = to - (parseInt(dateFrom) * 60 * 60);
            }
        }
        
        Promise.resolve( getApiReceiveEdgeDataQueryRange(infomation.id, infomation.product, String(from), String(to)) )
        .then( queryData => {

            let date = [];
            let obj = {};

            for( const data of queryData )
            {
                if( !obj.hasOwnProperty(data.field) )
                {
                    obj[data.field] = [];
                }

                for( const val of data.values )
                {
                    obj[data.field].push( val );

                    if( date.indexOf(val[0]) === -1 )
                    {
                        date.push(val[0]);
                    }
                }
            }

            return {obj: obj, date: date};
        })
        .then( sortData => {
            let data = [];

            for( let date of sortData.date )
            {
                let info = {...edgeDataFormat};
                
                info.date = date;
                info.longitude = getObjValue(date, sortData.obj, 'longitude');
                info.latitude = getObjValue(date, sortData.obj, 'latitude');
                info.freq = getObjValue(date, sortData.obj, 'freq');
                info.plp = getObjValue(date, sortData.obj, 'plp');
                info.lock = getObjValue(date, sortData.obj, 'lock');
                info.speed = getObjValue(date, sortData.obj, 'speed');
                info.rssi = getObjValue(date, sortData.obj, 'rssi');
                info.snr = getObjValue(date, sortData.obj, 'snr');
                info.mer = getObjValue(date, sortData.obj, 'mer');
                info.fer = getObjValue(date, sortData.obj, 'fer');

                data.push(info);
            }

            return data;
        })
        .then( dataArr => {
            setDrawData(dataArr);
            setCurLogData(dataArr.map( (item, idx) => (
                <tr key={idx} onClick={() => {infoResult( [item.longitude, item.latitude], idx )}}>
                    <td>{convertTzDate(item.date)}</td>
                    <td>{item.freq}</td>
                    <td>{item.plp}</td>
                    <td>{item.lock}</td>
                    <td>{item.speed}</td>
                    <td>{item.rssi}</td>
                    <td>{item.snr}</td>
                    <td>{item.mer}</td>
                    <td>{item.fer}</td>
                </tr>
            )));
            loading(false);
        })
        .catch( e => {
            loading(false);
        });
    }

    const onClickDraw = () => {

        if( !drawData )
        {
            showToast('no draw data', 'error');
        }
        else
        {
            loading(true);
            setPreLogData(curLogData);
            setDrawId(infomation.id);
            drawResult({data: drawData, id: infomation.id});
        }
    }

    const onClickExport = () => {
        
        const ws = xlsxUtils.json_to_sheet(drawData);
        const wb = xlsxUtils.book_new();

        let filename = commonLogDate() + '_mobile.csv';
        xlsxUtils.book_append_sheet(wb, ws, "Sheet1");
        xlsxWriteFile(wb, filename)
    }

    function runUpdate()
    {
        setUpdate(!update);
    }

    const closeOffcanvas = () => {
        handleClose();
        show = false;
    }

    useEffect( () => {
        getEdgeInfo();
    }, [show, update]);

    return (
        <>
            <Offcanvas show={show} onHide={closeOffcanvas} placement="end">
                <Offcanvas.Header>
                    <BsFillArrowLeftSquareFill cursor={'pointer'} size="25" onClick={onClickBackCanvas}></BsFillArrowLeftSquareFill>
                    <Offcanvas.Title>{curEdgeId}</Offcanvas.Title>
                    <Button variant='close' className="btn-close-white" onClick={closeOffcanvas}></Button>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Offcanvas.Title>Infomation</Offcanvas.Title>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Name</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={infomation.name} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Id</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={infomation.id} readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Fingerprint</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={infomation.fingerprint} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Lastest Check in</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={updateUTCDate(new Date(infomation.sec*1000))} readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Freq</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.freq} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">PLP</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.plp} readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Lock</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.lock} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">Speed</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.speed} readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">RSSI</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.rssi} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">FER</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.fer} readOnly/>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">SNR</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.snr} readOnly/>
                            </div>
                        </div>
                        <div className="d-flex col-6">
                            <div className="col-4 label-box">MER</div>
                            <div className="col-8 px-1">
                                <input className="form-control input-box" type="text" value={edgeData.mer} readOnly/>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <Offcanvas.Title>{`Search (${drawData.length})`}</Offcanvas.Title>
                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            <span className="space-text"> From </span>
                            <SeletorWithCalendar result={onChangeFrom} label='From'
                                val={dateFrom} setVal={setDateFrom}
                                opt={optSelectorFrom} setOpt={setOptSelectorFrom}
                            ></SeletorWithCalendar>
                            <span className="space-text"> To </span>
                            <SeletorWithCalendar result={onChangeTo} label='To'
                                val={dateTo} setVal={setDateTo}
                                opt={optSelectorTo} setOpt={setOptSelectorTo}
                            ></SeletorWithCalendar>
                        </div>
                        <div className="d-flex">
                            <Button variant='primary' className="btn-sm ms-1" onClick={onClickSearch}>Search</Button>
                            <Button variant='primary' className="btn-sm ms-1" onClick={onClickDraw}>Draw</Button>
                            <Button variant='primary' className="btn-sm ms-1" onClick={onClickExport}>Export</Button>
                        </div>
                    </div>
                    <div className="edge-detail-log-table mt-2">
                        <table className="table text-center table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Freq</th>
                                    <th>PLP</th>
                                    <th>Lock</th>
                                    <th>Speed</th>
                                    <th>RSSI</th>
                                    <th>SNR</th>
                                    <th>MER</th>
                                    <th>FER</th>
                                </tr>
                            </thead>
                            <tbody>
                                {curLogData}
                            </tbody>
                        </table>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}